import {compiler} from 'markdown-to-jsx';

type Props = {
  value: string;
}

const overrides = {
  p: {
    props: {
      className: 'mb-4',
    },
  },
  li: {
    props: {
      'data-before': '►',
      className: 'my-4 before:content-[attr(data-before)] before:inline-block before:mr-2'
    }
  }
};

export default function Markdown({ value }: Props) {
  return compiler(value, {
    wrapper: null,
    forceBlock: true,
    overrides,

    /**
     * We need this to underline text, since it is not supported by markdown,
     * we have to wait for this pull request to be merged so we can extend the rules
     * to create a custom underline parser.
     *
     * https://github.com/probablyup/markdown-to-jsx/pull/406
     */
    disableParsingRawHTML: false,
  });
}
